import React from 'react';
import {NeuroMessage, TransitionContainer} from "@ignitesales/neuro-application";
import {GuideNameMessage, useDialogueContext} from "../../../../../../shared/js";
import ProgressBar from "./ProgressBar";

const TexturedBar = () => {
    const { getPagePathMessageId } = useDialogueContext();
    const messageId = getPagePathMessageId();
    const componentClass = "texturedBar";

    return <div className={componentClass}>
        <div className="titleSection">
            <GuideNameMessage />
        </div>
        <div className="texturedSection">
            <TransitionContainer className="sidebarTransitionContainer" transitionKey={messageId}>
                <div className={`${componentClass}__text`}>
                    <NeuroMessage id={messageId} tagName="h4" shouldHideIfNotFound={true} />
                </div>
            </TransitionContainer>
            <div className={`${componentClass}__progressBar`}>
                <ProgressBar />
            </div>
        </div>
    </div>;
};

export default TexturedBar;
